import { Component, Input, inject, signal } from '@angular/core';

import { AtendimentoPessoaModel } from '../../../model/atendimento/atendimento-pessoa.model';
import { AuthService } from '../../../service/auth.service';
import { MethodsUtils } from '../../../util/methods.utils';

@Component({
  selector: 'app-avatar-pessoa',
  standalone: true,
  imports: [],
  templateUrl: './avatar-pessoa.component.html',
  styleUrl: './avatar-pessoa.component.css'
})
export class AvatarPessoaComponent {
  @Input() tamanho = 34;

  @Input() set pessoa(valor: AtendimentoPessoaModel | null | undefined) {
    this.pessoaAtual.set(valor ?? null);
    this.fotoComErro.set(false);
  }

  readonly pessoaAtual = signal<AtendimentoPessoaModel | null>(null);
  readonly fotoComErro = signal(false);

  private readonly grupo = inject(AuthService).getUsuarioLogadoClariBot()?.grupo;

  get foto(): string | null {
    const pessoa = this.pessoaAtual();
    if (this.fotoComErro() || !pessoa?.uuid || !pessoa.extensaoImg) return null;
    return MethodsUtils.urlFotoUsuario(this.grupo, pessoa.uuid, pessoa.extensaoImg);
  }

  get inicial(): string {
    return MethodsUtils.inicialDoNome(this.pessoaAtual()?.nome);
  }
}
